<ng-container *ngIf="closeButton">
  <div class="modal-content-wrapper__close-button-container">
    <ng-content select="[modal-close]"></ng-content>
  </div>
</ng-container>

<div class="modal-content-wrapper" [ngClass]="size">
  <div class="modal-content-wrapper__header">
    <ng-content select="[modal-title]"></ng-content>
  </div>

  <div class="modal-content-wrapper__body">
    <ng-content select="[modal-body]"></ng-content>
  </div>

  <div class="modal-content-wrapper__footer">
    <ng-content select="[modal-footer]"></ng-content>
  </div>
</div>
